import { Link } from "react-router-dom";
import { ArrowRight, Download, Share2, Radio } from "lucide-react";
import { toast } from "sonner";
import { LiveBriefingPlayer, useBriefingMeta } from "@/components/LiveBriefing";
import { useAuth } from "@/contexts/AuthContext";

const B = process.env.REACT_APP_BACKEND_URL;

export default function Briefing() {
  const meta = useBriefingMeta("full");
  const { user } = useAuth();
  const share = async () => {
    const url = `${window.location.origin}/briefing`;
    if (navigator.share) { try { await navigator.share({ title: "VISMARKS Live Briefing", url }); return; } catch { /* cancelled */ } }
    await navigator.clipboard.writeText(url); toast.success("Link copied");
  };
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white" data-testid="briefing-page">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-10">
        <div className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.3em] text-[#FF3B30] font-bold"><Radio className="h-3.5 w-3.5 animate-pulse" /> VISMARKS global briefing</div>
        <h1 className="mt-3 text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight leading-[0.95]">Transform your store<br />into a global theatre.</h1>
        <p className="mt-4 text-base text-neutral-400 max-w-2xl">{meta?.presenter || "Our presenter"} explains how Visibility Intelligence scans the globe for your customers, why once listed means always listed, and how to start tonight with 5 free listings.</p>
        {meta === null ? (
          <div className="mt-8 rounded-2xl border border-dashed border-white/15 p-12 text-center text-neutral-500" data-testid="briefing-empty">The briefing is being produced — check back shortly.</div>
        ) : (
          <>
            <div className="mt-8 hidden md:block"><LiveBriefingPlayer cut="full" testId="briefing-player-wide" /></div>
            <div className="mt-8 md:hidden max-w-[420px] mx-auto"><LiveBriefingPlayer cut="full" vertical testId="briefing-player-tall" /></div>
            <div className="mt-5 flex flex-wrap items-center gap-3">
              {!user && <Link to="/register?role=seller" data-testid="briefing-signup" className="inline-flex h-11 px-6 items-center rounded-full bg-[#FF3B30] text-white font-bold text-sm">Sign up free — 5 listings <ArrowRight className="h-4 w-4 ml-1" /></Link>}
              <button onClick={share} data-testid="briefing-share" className="inline-flex h-11 px-5 items-center gap-2 rounded-full border border-white/20 text-sm font-semibold hover:bg-white/5"><Share2 className="h-4 w-4" /> Share</button>
              <a href={`${B}/api/marketing/kit/public/briefing?format=16x9&cut=full&download=1`} data-testid="briefing-download" className="inline-flex h-11 px-5 items-center gap-2 rounded-full border border-white/20 text-sm font-semibold hover:bg-white/5"><Download className="h-4 w-4" /> Download</a>
            </div>
            {meta?.script?.length > 0 && (
              <details className="mt-10 rounded-2xl border border-white/10 bg-[#0F0F10] p-5" data-testid="briefing-transcript">
                <summary className="cursor-pointer font-bold">Transcript</summary>
                <div className="mt-4 space-y-4 text-sm text-neutral-300 leading-relaxed">
                  {meta.script.map((line, i) => (
                    <div key={i}><div className="text-[10px] uppercase tracking-widest text-[#007AFF] mb-1">{meta.captions?.[i]}</div>{line}</div>
                  ))}
                </div>
              </details>
            )}
          </>
        )}
      </div>
    </div>
  );
}
